import styled from 'styled-components';
import { Anchor } from '@atlassiansox/bxp-content-framework';
export const LogoLink = styled(Anchor) `
  align-items: center;
  align-self: stretch;
  display: flex;
  padding: 1rem;
`;
//# sourceMappingURL=Logo.styles.js.map